/**
 * Represents the type of a [[PhoneNumber]].
 */
export var PhoneNumberType;
(function (PhoneNumberType) {
    /**
     * A home phone number.
     */
    PhoneNumberType["Home"] = "Home";
    /**
     * A mobile phone number.
     */
    PhoneNumberType["Mobile"] = "Mobile";
    /**
     * A work phone number.
     */
    PhoneNumberType["Work"] = "Work";
    /**
     * A business phone number.
     */
    PhoneNumberType["Business"] = "Business";
    /**
     * A fax number.
     */
    PhoneNumberType["Fax"] = "Fax";
})(PhoneNumberType || (PhoneNumberType = {}));
//# sourceMappingURL=phone-number-type.js.map